
import {defineStore} from 'pinia';
var project_name = process.env.VUE_APP_PROJECT_NAME;
const cookie_local_storage_key = project_name + "_cookie_accept";

const cookieValue = localStorage.getItem(cookie_local_storage_key) || false;

export const useCookieStore = defineStore('cookies', {
    state: () => ({        
        accepted: cookieValue == 'accepted'             
    }), 

    actions: {
        setAccept(){
            localStorage.setItem(cookie_local_storage_key,"accepted");
            this.accepted = true;
        }        
    }    
})
